<div class="header-bar">
  <h1 *ngIf="organisationTypeId == 3 || organisationTypeId == 4">Supplier Jobs Report</h1>
  <h1 *ngIf="organisationTypeId == 1">Engineius Jobs Report</h1>
</div>
<div class="content-container">
  <form (ngSubmit)="search()" style="width: 100%">
    <div class="ui-g filterPanel form-group card">
      <div class="ui-g-12 ui-md-3 ui-lg-2">
        <span class="md-inputfield filterItem">
          <p-calendar
            [(ngModel)]="filterVal.filters.createDateFrom.value"
            name="createDateFrom"
            dateFormat="dd/mm/yy"
            >></p-calendar
          >
          <label>Date Created From</label>
        </span>
      </div>

      <div class="ui-g-12 ui-md-3 ui-lg-2">
        <span class="md-inputfield filterItem">
          <p-calendar
            [(ngModel)]="filterVal.filters.createDateTo.value"
            name="createDateTo"
            dateFormat="dd/mm/yy"
            >></p-calendar
          >
          <label>Date Created To</label>
        </span>
      </div>

      <div class="ui-g-12 ui-md-3 ui-lg-2">
        <span class="md-inputfield filterItem">
          <p-calendar
            [(ngModel)]="filterVal.filters.completedDateFrom.value"
            name="completedDateFrom"
            dateFormat="dd/mm/yy"
            >></p-calendar
          >
          <label>Date Completed From</label>
        </span>
      </div>

      <div class="ui-g-12 ui-md-3 ui-lg-2">
        <span class="md-inputfield filterItem">
          <p-calendar
            [(ngModel)]="filterVal.filters.completedDateTo.value"
            name="completedDateTo"
            dateFormat="dd/mm/yy"
            >></p-calendar
          >
          <label>Date Completed To</label>
        </span>
      </div>

      <div class="ui-g-12 ui-md-6 ui-lg-4">
        <div class="ui-g-3">
          <label>Movement Type</label>
        </div>
        <div class="ui-g-9">
          <p-dropdown
            [options]="taskTypes"
            autoWidth="false"
            [style]="{ width: '100%' }"
            [(ngModel)]="filterVal.filters.type.value"
            name="type"
          ></p-dropdown>
        </div>
      </div>

      <div
        class="ui-g-12 ui-md-6 ui-lg-4"
        *ngIf="organisationTypeId == 2 || organisationTypeId == 3 || organisationTypeId == 4"
      >
        <div class="ui-g-3">
          <label>Tag</label>
        </div>
        <div class="ui-g-9">
          <p-dropdown
            [options]="tags"
            autoWidth="false"
            [style]="{ width: '100%' }"
            [(ngModel)]="filterVal.filters.tag.value"
            name="tag"
          ></p-dropdown>
        </div>
      </div>

      <div
        class="ui-g-12 ui-md-6 ui-lg-4"
        *ngIf="organisationTypeId == 2 || organisationTypeId == 3 || organisationTypeId == 4"
      >
        <div class="ui-g-3">
          <label>Account Code</label>
        </div>
        <div class="ui-g-9">
          <p-dropdown
            [options]="costCodes"
            autoWidth="false"
            [style]="{ width: '100%' }"
            [(ngModel)]="filterVal.filters.costCode.value"
            name="costCode"
          ></p-dropdown>
        </div>
      </div>

      <div
        class="ui-g-12 ui-md-6 ui-lg-4"
        *ngIf="organisationTypeId == 2 || organisationTypeId == 4"
      >
        <div class="ui-g-3">
          <label>Departament</label>
        </div>
        <div class="ui-g-9">
          <p-dropdown
            [options]="departments"
            autoWidth="false"
            [style]="{ width: '100%' }"
            [(ngModel)]="filterVal.filters.department.value"
            name="department"
          ></p-dropdown>
        </div>
      </div>

      <div
        class="ui-g-12 ui-md-6 ui-lg-4"
        *ngIf="organisationTypeId == 2 || organisationTypeId == 4"
      >
        <div class="ui-g-3">
          <label>Team</label>
        </div>
        <div class="ui-g-9">
          <p-dropdown
            [options]="teams"
            autoWidth="false"
            [style]="{ width: '100%' }"
            [(ngModel)]="filterVal.filters.team.value"
            name="team"
          ></p-dropdown>
        </div>
      </div>

      <div
        class="ui-g-12 ui-md-6 ui-lg-4"
        *ngIf="organisationTypeId == 3 || organisationTypeId == 4"
      >
        <div class="ui-g-3">
          <label>Region</label>
        </div>
        <div class="ui-g-9">
          <p-dropdown
            [options]="regions"
            autoWidth="false"
            [style]="{ width: '100%' }"
            [(ngModel)]="filterVal.filters.region.value"
            (onChange)="regionChange($event)"
            name="region"
          ></p-dropdown>
        </div>
      </div>

      <div
        class="ui-g-12 ui-md-6 ui-lg-4"
        *ngIf="organisationTypeId == 3 || organisationTypeId == 4"
      >
        <div class="ui-g-3">
          <label>Depot</label>
        </div>
        <div class="ui-g-9">
          <p-dropdown
            [options]="depots"
            autoWidth="false"
            [style]="{ width: '100%' }"
            [(ngModel)]="filterVal.filters.depot.value"
            name="depot"
          ></p-dropdown>
        </div>
      </div>

      <div class="ui-g-12 ui-md-6 ui-lg-4" *ngIf="organisationTypeId == 1">
        <div class="ui-g-3">
          <label>Supplier</label>
        </div>
        <div class="ui-g-9">
          <p-dropdown
            [options]="suppliers"
            autoWidth="false"
            [style]="{ width: '100%' }"
            filter="true"
            [(ngModel)]="filterVal.filters.supplier.value"
            name="supplier"
          ></p-dropdown>
        </div>
      </div>

      <div class="ui-g-12 ui-md-6 ui-lg-4">
        <div class="ui-g-3">
          <label>Status</label>
        </div>
        <div class="ui-g-9">
          <p-multiSelect
            [options]="jobStatuses"
            autoWidth="false"
            [style]="{ width: '100%' }"
            [(ngModel)]="filterVal.filters.status.value"
            name="status"
          ></p-multiSelect>
        </div>
      </div>

      <div class="ui-g-12">
        <button
          pButton
          type="button"
          label="Clear"
          class="ui-button btn-to-right"
          (click)="clearFilter(dt)"
        ></button>
        <button pButton type="submit" label="Search" class="ui-button btn-to-right"></button>
      </div>
    </div>
  </form>

  <p-table
    #dt
    [value]="rows"
    [lazy]="true"
    [rows]="10"
    [responsive]="true"
    [paginator]="true"
    rowHover="true"
    resizableColumns="true"
    [tableStyle]="{ width: 1000 + maxTasks * 400 + 'px' }"
    [totalRecords]="page.total"
    (onLazyLoad)="onGridLazyLoad($event, foobar())"
    [loading]="isLoading"
    [rowsPerPageOptions]="[5, 10, 20]"
    [pageLinks]="3"
    [(selection)]="selectedJob"
    selectionMode="single"
  >
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let column of columns" style="{{ column?.style }}">{{ column.label }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr [pSelectableRow]="item" class="no-wrap-cells">
        <td *ngFor="let cell of item.cells" style="{{ item.style }}">
          <span *ngIf="cell.cellType == 'date'">
            {{ moment(cell.value).format(cell.dateFormat) }}
          </span>
          <span *ngIf="cell.cellType == 'currency'">
            {{ cell.value | currency : 'GBP' : 'symbol' : '1.2-2' }}
          </span>
          <span *ngIf="!cell.cellType">
            {{ cell.value }}
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="ui-g-12" style="height: 40px; margin-top: 20px">
    <button
      type="button"
      pButton
      icon="fa ui-icon-file-download"
      label="Download"
      class="ui-button btn-to-right"
      (click)="downloadReport()"
      [disabled]="page.total == 0"
    ></button>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
